export default "/images/avatar-1.png?d79cbd6eda5ee96bfdfc8773ab6c1ee7";